import {SceneAudio} from "./StoryModel";

export const SFXMap: Record<string, string> = {
    "001": "sc_001_XR103A_ Music Show Open No Singing",
    "002": "sc_002_XR103A_003_ Rising String Notes",
    "003": "sc_003_XR103A_007_Books Sliding and Impact",
    "004": "sc_004_XR103A_007_Whomps Brad and Xavier Tumble",
    "005": "sc_005_XR103A_008_Music Rising Intensity Notes",
    "006": "sc_006_XR103A_009_Whoosh for Xavier Jump",
    "007": "sc_007_XR103A_009_Chords_to the secret museum",
    "008": "sc_008XR101B_019_Rising Notes",
    "009": "sc_009_XR101B_006_Fluttery Flute",
    "010": "sc_010_XR103A_078_Background",
    "011": "sc_011_XR102A_018_Triumphant Music Xavier",
    "012": "sc_012_XR102A_018_Triumphant Music Yadina",
    "013": "sc_013_XR102A_050_Paper Rustling",
    "014": "sc_014_XR102A_050_Windy Whoosh Paper Blowing Away",
    "015": "sc_015_XE111B_001_Music (Gameshowy)",
    "016": "sc_016_XR111B_059_Background Music",
    "018": "sc_018_XR111B_101_Bell Hit",
    "019": "sc_019_XR111B_131_Whoosh",
    "020": "sc_020_XR113A_095_Triumphant Hit",
    "021": "sc_021_XR111B_135_Xavier landing",
    "023": "sc_023_XR113A_112_Brad hitting ground",
    "024": "sc_024_XR101B_005_Water Freeze No Chime",
    "025": "sc_025_XR111B_014_Triumphant Intro",
    "026": "sc_026_XR111B_015_Triumphant Into",
    "027": "sc_027_XR111B_067_TaDa Orchestra",
    "028": "sc_028_XR111B_070_Quick Build into Crescendo",
    "029": "sc_029_XR111B_072_Triumphant Build",
    "030": "sc_030_XR102A_019_Spooky Orchestra",
    "031": "sc_031_XR111B_081_Tightrope Walker Music",
    "032": "sc_032_XR111B_081_Short Nervous Brad Cue",
    "033": "sc_033_XR113A_054_Sizzling",
    "034": "sc_034_102A_004_Orchestra Hit",
    "035": "sc_035_XR102A_007_Orchestra Crescendo",
    "036": "sc_036_XR103A_063_Rising chords",
    "036b": "sc_036b_XR103A_063_Rising chords",
    "037": "sc_037_XR103A_074_Rustling sounds",
    "039": "sc_039_102A_072_Upward Chimes",
    "040": "sc_040_XR102A_075_Spooky Orchestra",
    "041": "sc_041_XR102A_080_Big Bass and Bell",
    "042": "sc_042_XR102A_080_Triumphant Orchestra",
    "043": "sc_043_XR102A_096_Spooky Horns and Bells",
    "044": "sc_044_XR102A_096_Wind Gusts",
    "045": "sc_045_XR102A_096_Orchestra (there is no organ)",
    "046": "sc_046_XR111B_094_DUn Dun Dun Music",
    "047": "sc_047_XR111B_094_Eagle",
    "048": "sc_048_XR111B_097_Eerie Music",
    "049": "sc_049_XR111B_002_Heavy Book Impact",
    "050": "sc_050_XR101B_006_Bubbles _ Bubble Pops",
    "051": "sc_051_XR102A_003_Flashlight Switch",
    "052": "sc_052_XR102A_014_Cushion Impact and Squwak",
    "053": "sc_053_XR102_018_Bouncing",
    "053b": "sc_053b_XR102_018_Bouncing",
    "054": "sc_054_XR102A_018_Thud Bodyfall",
    "055": "sc_055_XR113B_067_Triumphant Music",
    "056": "sc_056_XR113B_099_Flat Bass-y Horns",
    "057": "sc_057_XR111B_003_Whale Noise",
    "058": "sc_058_XR111B_005_Book Drop",
    "059": "sc_059_XR103A_059_Ambient sound with birds",
    "060": "sc_060_XR118B_006_Slimey Octopus Sounds",
    "061": "sc_061_XR116B_064_Big Band Jazz",
    "062": "sc_062_XR111B_125_Eating Popcorn",
    "063": "sc_063_XR113A_105_Paper Rusrlt",
    "064": "sc_064_XR102A_046_Crow Squawk",
    "065": "sc_065_XR118_026_Egyption Style Muisc",
    "066": "sc_066_XR113B_018_Glass Clamks Scrapes",
    "067": "sc_067_XR113B_021_Glass thud on counter",
    "068": "sc_068_XR113B_009_Bite Sandwich",
    "069": "sc_069_XRMovie_689_Majestic Music",
    "070": "sc_070_XRMovie_695_Zoom Sqeak 1",
    "071": "sc_071_XRMovie_695_Zoom Sqeak 2",
    "072": "sc_072_XRMovie_695_Dun Dun Dun Strings",
    "073": "sc_073_quicktada",
    "074": "sc_074_surprising",
    "075": "sc_075_bestfriends",
    "076": "sc_076_hishome",
    "077": "sc_077_xr111B_080_Circus BG Music Alt",
    "078": "sc_078_kiss",
    "079": "sc_079_pop1",
    "080": "sc_080_pop2",
    "081": "sc_081_pop3",
    "082": "sc_082_airplane",
    "083": "sc_083_spaceship",
    "084": "sc_084_horns",
    "085": "sc_085_hungry",
    "086": "sc_86_splat",
    "087": "sc_87_underwater",
    "088": "sc_88_shower",
    "089": "sc_89_clock",
    "089a": "sc_89_clock-long",
    "090": "sc_90_sniff",
    "091": "sc_91_chalk",
    "092": "sc_92_glisten",
    "092a": "sc_92_glisten_alt",
    "093": "sc_93_ambientbirds",
    "094": "sc_94_boing",
    "095": "sc_95_party",
    "096": "sc_96_chime",
    "097": "sc_97_hearts",
    "098": "sc_98_sip",
    "099": "sc_99_underwater",
    "100": "sc_100_swing",
    "101": "sc_101_painting",
};

export function SFX(value: SceneAudio, ...values: string[]): SceneAudio {
    if (typeof value === "object") {
        if (Array.isArray(value)) {
            return value.map((it) => typeof it === "string" ? SFXMap[it] ?? it : it);
        }
        const o1: SceneAudio = {};
        for (const p of Object.getOwnPropertyNames(value)) {
            o1[SFXMap[p] ?? p] = value[p];
        }
        return o1;
    }
    if (values.length === 0) {
        return SFXMap[value] ?? value;
    }
    const o2: SceneAudio = {};
    values.unshift(value);
    for (const v of values) {
        o2[SFXMap[v] ?? v] = 0;
    }
    return o2;
}
